<section id="index-masterhead-section" class="index-masterhead-section">
    <app-navbar [includeCenterLinks]="true"></app-navbar>

    <div id="index-masterhead-hero-section">
        <div class="container">
            <div class="row" id="index-masterhead-hero-section-row">

                <!-- Column Left -->
                <div class="col-lg-6 animate__animated animate__fadeInDown" id="hero-title-subtitle-column">
                    <div class="hero-eyebrow-pill">
                        <span class="dot"></span>
                        <span>Full-service software and hardware support</span>
                    </div>
                    <h1 class="text-white">You've had the dream,<br>we'll take it from here.</h1>
                    <p>Powell Industries designs and operates high-performance websites and SPAs, manages your domains and DNS, and runs CRM and VPS infrastructure so your team never has to think about servers, SSL, or uptime again.</p>

                    <h3 class="text-white">PI is here for you and we've got you<br> covered, from beginning to <span class="text-success">profit</span>.</h3>

                    <div class="hero-cta-group pt-3">
                        <a [href]="environment.portalLinks.registration">
                            <button class="btn btn-hero-primary my-3">Create your PI | Portal account</button>
                        </a><br>
                        <a href="#index-about-section">
                            <button class="btn btn-hero-secondary">Learn more about Powell Industries</button>
                        </a>
                    </div>
                </div>

                <!-- Column Right -->
                <div class="col-lg-6 animate__animated animate__fadeInUp" id="hero-title-portal-card-column">
                    <div class="portal-card">
                        <div class="portal-card-header">
                            <span class="portal-label">PI | Portal</span>
                            <span class="portal-status">
                                <span class="status-dot"></span>
                                All systems operational
                            </span>
                        </div>

                        <div class="portal-card-body">
                            <p class="text-secondary m-0">Your business, at a glance.</p>
                            <div class="portal-metric">
                                <span class="metric-label">Active environments</span>
                                <span class="metric-value">12</span>
                                <span class="metric-sub">Production, staging & preview</span>
                            </div>
                            <div class="portal-metric">
                                <span class="metric-label">Managed domains</span>
                                <span class="metric-value">38</span>
                                <span class="metric-sub">DNS, SSL & routing</span>
                            </div>
                            <div class="portal-metric">
                                <span class="metric-label">Average response time</span>
                                <span class="metric-value">64 ms</span>
                                <span class="metric-sub">Global edge network</span>
                            </div>
                        </div>

                        <div class="horizontal-decorator-line-transparent-dark"></div>

                        <div class="portal-card-footer">
                            <div class="portal-footer-item">
                                <span class="footer-label">Change window</span>
                                <span class="footer-value">Instant, with rollback</span>
                            </div>
                            <div class="portal-footer-item">
                                <span class="footer-label">CRM events today</span>
                                <span class="footer-value">14,209</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
